import { Spinner } from 'react-bootstrap';

const LoadingSpinner = ({ size, style }) => {
  return (
    <Spinner
      animation="border"
      role="status"
      style={{ color: '#0e2554', width: size || '1rem', height: size || '1rem', ...style }}
    >
      <span className="visually-hidden">Loading...</span>
    </Spinner>
  );
};

export default LoadingSpinner;
